import {connect} from 'react-redux';
import UploadingFilePopUp from './UploadingFilePopUp';
import {hideUploadingFilePopUp} from 'common/actions/uploadingFilePopUp/hideUploadingFilePopUp';

const mapStateToProps = ({
                           uploadingFilePopUp: {showUploadingFilePopUp},
                         }) => ({
  showUploadingFilePopUp,
});

export default connect(
  mapStateToProps,
  {hideUploadingFilePopUp}
)(UploadingFilePopUp);
